import { Row, Col } from "antd";
import {
  OrderConst,
  OrderModel,
  OrderPackingListModel,
  OrderShippingConst,
} from "states/order/order.models";
import { OrderCancelButton } from "./order-cancel-button";
import { OrderReceivedButton } from "./order-received-button";
import { OrderShippingButton } from "./order-shipping-button";
import { OrderReturnedButton } from "./order-returned-button";
import { OrderReturningButton } from "./order-returning-button";
import { OrderVerifyButton } from "./order-verify-button";

export interface IOrderActionsProps {
  order: OrderModel;
  handleCreatePackingList: (model: OrderPackingListModel) => void;
  loadOrder: (orderId: string) => Promise<void>;
}

export function OrderActions(props: IOrderActionsProps) {
  const { order, handleCreatePackingList, loadOrder } = props;

  return (
    <>
      {order.type === OrderConst.orderType.online &&
        order.status === OrderConst.status.pending && (
          <Row gutter={[8, 8]} align="middle" className="mt-2">
            <Col span="24">
              <OrderVerifyButton
                orderId={order.id}
                onSuccess={() => loadOrder(order.id)}
              />
            </Col>
          </Row>
        )}
      {order.type === OrderConst.orderType.online &&
        order.status === OrderConst.status.onOrder && (
          <Row gutter={[8, 8]} className="mt-2">
            <Col span="24">
              <OrderShippingButton
                order={order}
                handleCreatePackingList={handleCreatePackingList}
                onSuccess={() => loadOrder(order.id)}
              />
            </Col>
          </Row>
        )}
      {order.type === OrderConst.orderType.online &&
        order.status === OrderConst.status.shipping && (
          <Row gutter={[8, 8]} className="mt-2">
            <Col span="24">
              <OrderReceivedButton
                orderPackingListId={order.orderPackingLists[0].id}
                onSuccess={() => loadOrder(order.id)}
              />
            </Col>
          </Row>
        )}
      {(order.status === OrderConst.status.pending ||
        order.status === OrderConst.status.onOrder) && (
        <Row gutter={[8, 8]} align="middle" className="mt-2">
          <Col span="24">
            <OrderCancelButton
              orderId={order.id}
              onSuccess={() => loadOrder(order.id)}
            />
          </Col>
        </Row>
      )}
      {order.status === OrderConst.status.shipping &&
        order.type === OrderConst.orderType.online &&
        order.orderPackingLists[0]?.type ===
          OrderShippingConst.shippingType.delivery && (
          <Row gutter={[8, 8]} align="middle" className="mt-2">
            <Col span="24">
              <OrderReturningButton
                orderShippingId={order.orderPackingLists[0].id}
                onSuccess={() => loadOrder(order.id)}
              />
            </Col>
          </Row>
        )}
      {order.status === OrderConst.status.returning &&
        order.type === OrderConst.orderType.online &&
        order.orderPackingLists[0]?.type ===
          OrderShippingConst.shippingType.delivery && (
          <Row gutter={[8, 8]} align="middle" className="mt-2">
            <Col span="24">
              <OrderReturnedButton
                orderShippingId={order.orderPackingLists[0].id}
                onSuccess={() => loadOrder(order.id)}
              />
            </Col>
          </Row>
        )}
    </>
  );
}
